// Simple command-driven cultivation (修仙) game world logic (final optimized architecture)
import gameController from './modules/game-controller/GameController.js';

// Export the game controller interface for backward compatibility
export const state = gameController.getGameState();
export const parseCommand = gameController.executeCommand.bind(gameController);
export const listCommands = gameController.getAvailableCommands.bind(gameController);
export const suggest = gameController.getCommandSuggestions.bind(gameController);
